import { render, staticRenderFns } from "./ManageLicenseStatusPage.vue?vue&type=template&id=084cb702&scoped=true"
import script from "./ManageLicenseStatusPage.vue?vue&type=script&lang=js"
export * from "./ManageLicenseStatusPage.vue?vue&type=script&lang=js"
import style0 from "./ManageLicenseStatusPage.vue?vue&type=style&index=0&id=084cb702&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084cb702",
  null
  
)

export default component.exports